import { ErrorStateBackLink } from "@packages/core-client/errors/ErrorStateBackLink.tsx";
import { PageTitle } from "@packages/core-client/components/PageTitle.tsx";
import { useI18nextInstance } from "@squide/i18next";
import { useTranslation } from "react-i18next";
import { i18NextInstanceKey } from "../i18next.ts";

export function NotFoundPage() {
    const i18nextInstance = useI18nextInstance(i18NextInstanceKey);
    const { t } = useTranslation("NotFoundPage", { i18n: i18nextInstance });

    return (
        <div className="flex h-dvh flex-col items-center justify-center text-center">
            <title>{`Workleap - ${t("title")}`}</title>
            <div className="flex flex-col items-center gap-2">
                <span aria-hidden="true" className="text-muted-foreground text-sm font-medium" data-public>
                    {t("code")}
                </span>
                <PageTitle data-public>{t("description")}</PageTitle>
            </div>
            <ErrorStateBackLink href="/" className="mt-6">
                {t("backHome")}
            </ErrorStateBackLink>
        </div>
    );
}
